import ShieldCheckmarkIcon from "../../assets/icons/shield-checkmark.svg?react";
import FolderCheckmarkIcon from "../../assets/icons/folder-checkmark.svg?react";
import SettingsOutlinedIcon from "../../assets/icons/settings-outlined.svg?react";
import CircleCheckmarkIcon from "../../assets/icons/circle-checkmark.svg?react";

export const i18key = "pages.home.whyChooseUs";
export const benefitsData = [
  {
    iconName: CircleCheckmarkIcon,
    titleKey: `${i18key}.benefits.benefit1.title`,
    descriptionKey: `${i18key}.benefits.benefit1.desc`,
  },
  {
    iconName: FolderCheckmarkIcon,
    titleKey: `${i18key}.benefits.benefit2.title`,
    descriptionKey: `${i18key}.benefits.benefit2.desc`,
  },
  {
    iconName: ShieldCheckmarkIcon,
    titleKey: `${i18key}.benefits.benefit3.title`,
    descriptionKey: `${i18key}.benefits.benefit3.desc`,
  },
  {
    iconName: SettingsOutlinedIcon,
    titleKey: `${i18key}.benefits.benefit4.title`,
    descriptionKey: `${i18key}.benefits.benefit4.desc`,
  },
];
